// extracted by mini-css-extract-plugin
module.exports = {"isSensitiveChip":"TagDropdown_isSensitiveChip__2oa9l","chip":"TagDropdown_chip__2aS9Z","option":"TagDropdown_option__zZlEK"};